module.exports = __webpack_public_path__ + "static/img/et.26d0337e.svg";